import { Expose, Type } from 'class-transformer';
import { CompanySpaceDto } from './company-space.dto';
import { CompanyAddressDto } from './company-address.dto';
import { CompanyStationsDto } from './company-stations.dto';
import { CompanySocialMediaDto } from './company-social-media.dto';
import { GetCompanyTypesResponseDto } from './get-company-types-response.dto';
import { GetMaxAllowedPermissionRequestDto } from './get-max-allowed-permission.request.dto';

export class CompanyResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'token' })
  token: string;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'spaces_id' })
  spacesId: number[];
  @Expose({ name: 'logo' })
  logo: string;
  @Expose({ name: 'number_of_users' })
  numberOfUsers: number;
  @Expose({ name: 'website' })
  website: string;
  @Expose({ name: 'industry' })
  industry: string;
  @Expose({ name: 'expertise' })
  expertise: string;
  @Expose({ name: 'invite_link' })
  inviteLink: string;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'priority_company_id' })
  priorityCompanyId: string;
  @Expose({ name: 'priority_contact_id' })
  priorityContactId: string;
  @Expose({ name: 'address' })
  @Type(() => CompanyAddressDto)
  address: CompanyAddressDto;
  @Expose({ name: 'social_media' })
  @Type(() => CompanySocialMediaDto)
  socialMedia: CompanySocialMediaDto;
  @Expose({ name: 'spaces' })
  @Type(() => CompanySpaceDto)
  spaces: CompanySpaceDto[];
  @Expose({ name: 'company_type' })
  @Type(() => GetCompanyTypesResponseDto)
  companyType: GetCompanyTypesResponseDto;
  @Expose({ name: 'stations' })
  @Type(() => CompanyStationsDto)
  stations: CompanyStationsDto;
  @Expose({ name: 'max_allowed_permissions' })
  @Type(() => GetMaxAllowedPermissionRequestDto)
  maxAllowedPermissions: GetMaxAllowedPermissionRequestDto;
}
